<template>
  <div id="catalog_vue" class="pb_30">
    <div :class="{ mb_60: sortMode && isMobile }">
      <base-title
        :title="StringLanguage.catalog"
        :subtitle="StringLanguage.configurations"
        :link="'configuracoes'"
      >
        <base-button
          v-show="!sortMode"
          :text="StringLanguage.newCategory"
          :class="!!isMobile ? 'reverse w-100 mb_15' : 'mr_30'"
          @click="openAddOrEditDrawer('Category')"
        />

        <base-button
          :class="!!isMobile ? 'reverse w-100 mb_15' : ''"
          design="two"
          @click="openSortDrawer('Catalog')"
        >
          <p class="filter" v-if="!isMobile">
            <i class="fal fa-sort-size-up"></i>
          </p>
          <p class="filter" v-else>
            {{ StringLanguage.sort }}
          </p>
        </base-button>
      </base-title>

      <base-empty
        v-if="catalog.items.length == 0"
        title="Você ainda não tem categorias cadastradas."
        message="Suas categorias e produtos irão aparecer por aqui."
        buttonText="Adicionar categoria"
        @onClick="openAddOrEditDrawer('Category')"
      />

      <base-box class="search-box">
        <base-input
          :placeholder="StringLanguage.search"
          class="w-100"
          ref="searchInput"
          :value="search.term"
          v-on:keyup="filterCatalog"
          search
        />
      </base-box>

      <div
        v-for="category in getCategoryList()"
        :key="category._id"
        class="box-category"
        :class="{ sorting: category.sorting }"
      >
        <div
          class="category-title"
          :style="category.items.length === 0 && 'border-radius: 5px'"
        >
          <span>{{ category.name }}</span>
          <div>
            <div class="category-actions">
              <i
                class="fal fa-pen mr_10"
                @click="openAddOrEditDrawer(category, category._id, true)"
              ></i>
              <i
                class="fal fa-sort-size-up"
                :class="!category.show ? 'mr_10' : ''"
                @click="openSortDrawer(category)"
              ></i>
              <i
                v-if="!category.show"
                class="fal fa-eye-slash product-hidden"
              ></i>
            </div>
          </div>
        </div>

        <div>
          <!-- Aparecer enquanto fechado e ocultar durante busca -->

          <div class="box-product-container">
            <div
              v-for="product in getProductList(category)"
              @click="openAddOrEditDrawer(product, category._id, true)"
              class="box-product"
              :class="!!isMobile ? 'box-product--mobile' : ''"
              :key="product._id"
            >
              <div class="product-info">
                <div>
                  <div class="d-flex align-center">
                    <p v-if="product.highlight" class="highlight">
                      <i class="fas fa-star"></i>
                    </p>
                    <p class="product-name">{{ product.name }}</p>
                  </div>
                  <p class="product-description">{{ product.description }}</p>
                </div>
                <div v-if="product.show" class="product-price">
                  <p
                    v-if="
                      product.type !== 'simple' &&
                        !!product.sizes &&
                        product.sizes.length > 1
                    "
                    class="mb_5"
                  >
                    {{ StringLanguage.asFrom }}
                  </p>
                  <p>{{ getProductLowerPrice(product) }}</p>
                </div>
                <p v-else class="product-hidden">Oculto</p>
              </div>
              <div v-if="product.image" class="product-image">
                <img
                  :src="product.image ? getProductImage(product.image) : ''"
                  alt="Imagem do produto"
                />
              </div>
              <div v-else class="product-image product-image--none">
                <i class="fal fa-camera"></i>
              </div>
            </div>
            <div
              @click="
                openAddOrEditDrawer(
                  (category.mode === 'pizza'
                    ? 'flavor'
                    : category.mode
                  ).capitalize(),
                  category._id
                )
              "
              class="new-product"
              :class="!!isMobile ? 'new-product--mobile' : ''"
            >
              <i class="far fa-plus"></i>
              <span>{{ StringLanguage.addProduct }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!catalog || !catalog.items || catalog.items.length == 0">
        <base-add
          :text="StringLanguage.newCategory"
          @click.native="openAddOrEditDrawer('Category')"
          height="180px"
          class="w-100"
        />
      </div>
    </div>

    <!-- SALVAR SORT MOBILE -->
    <div v-if="isMobile && sortMode" class="save-sort">
      <base-button text="Salvar ordenação" @click="saveSort()" class="w-100" />
    </div>
    <!--  -->

    <!-- DRAWER -->
    <!-- <base-drawer
      ref="drawer"
      :originCatalog="catalog"
      v-on:updateCatalog="setCatalog"
    /> -->
    <base-add-drawer
      ref="add_or_edit_drawer"
      :originCatalog="catalog"
      @updateCatalog="setCatalog"
    />
    <!-- FIM -->

    <!-- SORT DRAWER -->
    <base-sort-drawer ref="sort_drawer" @saveSort="saveSort" />
    <!-- FIM -->
  </div>
</template>

<script>
import Vue from 'vue';
import store from '@/store';
import { mapState } from 'vuex';
import { getXAPIEnv } from '@/plugins/account';

import Builder from 'easyjs/lib/Schema/Components/Builder';
import CatalogAPI from '@/api/catalog';
import StoreAPI from '@/api/store';

import BaseDrawer from '@/containers/Catalog/CatalogDrawer';
import BaseSortDrawer from '@/containers/Catalog/SortDrawer';
import BaseAddDrawer from '@/containers/Catalog/AddDrawer';
import BaseTitle from '@/components/Title';
import BaseButton from '@/components/Button';
import BaseBox from '@/components/Box';
import BaseInput from '@/components/Input';
import BaseAdd from '@/components/Add';
import BaseEmpty from '@/components/Empty';

export default {
  components: {
    BaseDrawer,
    BaseSortDrawer,
    BaseAddDrawer,
    BaseTitle,
    BaseButton,
    BaseBox,
    BaseInput,
    BaseAdd,
    BaseEmpty,
  },
  data() {
    return {
      sortMode: false,
      catalog: {},
      backupCatalog: {},
      backupCategory: {},
      search: {
        id: null,
        term: null,
        enable: false,
      },
    };
  },
  mounted() {
    if (!this.isMobile) {
      this.$refs.searchInput.focus();
    }
  },
  created() {
    CatalogAPI.catalogCatalog(true, true).then(response => {
      this.catalog = Builder.mountSchema(response.getData({ type: 'catalog' }));
      Builder.executeOnSchema(this.catalog, item => {
        item.new = false;
      });
    });
  },
  methods: {
    getProductImage(image) {
      if (image.indexOf(process.env.VUE_APP_IMAGES_DEFAULT) !== -1) {
        return image;
      }
      return `${process.env.VUE_APP_IMAGES}/${getXAPIEnv()}/${image}`;
    },
    openSortDrawer(item) {
      this.backupCatalog = Builder.mountSchema(
        JSON.parse(JSON.stringify(this.catalog))
      );

      this.currentItem = item;

      if (item === 'Catalog') {
        this.currentItem = this.catalog;
      }

      this.$refs.sort_drawer.changeModel(this.currentItem);
      this.$forceUpdate();
    },
    openAddOrEditDrawer(item, parent, edit = false) {
      if (typeof item === 'string') {
        item = Builder.factory(item);
        item.new = true;
        item.mode = null;
      } else {
        item.new = false;
      }

      this.$refs.add_or_edit_drawer.changeModel(item, parent, edit);
      this.$forceUpdate();
    },
    filterCatalog(e) {
      if (this.search.id) {
        clearTimeout(this.search.id);
      }

      this.search.id = setTimeout(() => {
        this.search.term = e.target.value;
      }, 1000);
    },
    clearFilter() {
      if (this.search.id) {
        clearTimeout(this.search.id);
      }
      this.search.term = null;
    },
    getCatalog() {
      const catalogComp = this;
      CatalogAPI.catalogCatalog(false, true).then(response => {
        catalogComp.catalog = Builder.mountSchema(
          response.getData({
            type: 'catalog',
          })
        );

        Builder.executeOnSchema(catalogComp.catalog, item => {
          item.new = false;
        });
      });
    },
    getCategoryList() {
      return this.filterItems(this.catalog.items || []);
    },
    getProductLowerPrice(product) {
      const moneyFormatter = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });

      if (product.price) {
        return moneyFormatter.format(
          Math.min(+product.price, ...product.sizes.map(s => +s.price))
        );
      }

      return moneyFormatter.format(
        Math.min(...(product.sizes ? product.sizes.map(s => +s.price) : [0]))
      );
    },
    getProductList(category) {
      if (!this.search.term) {
        return category.items;
      }

      return this.isValidTerm(
        this.search.term.toLowerCase(),
        category.name.toLowerCase()
      )
        ? category.items
        : this.filterItems(category.items);
    },
    filterItems(items) {
      if (!this.search.term) {
        return items;
      }

      const searchTerm = this.search.term.toLowerCase();
      return (items || []).filter(i => {
        if (this.isValidTerm(searchTerm, i.name.toLowerCase())) return true;
        if (i.items.length > 0) {
          if (this.filterItems(i.items).length > 0) return true;
        }
      });
    },
    isValidTerm(searchTerm, term) {
      return term.indexOf(searchTerm) > -1;
    },
    saveSort() {
      const changedItems = [];
      const changedChildItems = [];

      this.catalog.items.forEach(category => {
        if (category.changed) {
          changedItems.push(category._id);
        }

        category.items.forEach(item => {
          if (item.changed) {
            changedChildItems.push(item._id);
          }
        });
      });

      const catalog = JSON.parse(JSON.stringify(this.catalog));
      catalog.items.forEach((category, i) => {
        category.position = i;
        category.items = category.items.map(item => {
          item.changed = changedChildItems.indexOf(item._id) !== -1;
          return item;
        });
        category.extra_ingredients = [];
        category.edges = [];
        category.doughs = [];
        category.changed = changedItems.indexOf(category._id) !== -1;
      });

      this.setCatalog(catalog, this.backupCatalog);
      this.backupCatalog = {};
    },
    setCatalog(item, backupCatalog) {
      let pack = null;

      if (!item._id && item.type != 'catalog') {
        item._id = Builder.generateRandomId('_');
        item.new = true;

        if (item.type == 'category') {
          const catalog = JSON.parse(JSON.stringify(this.catalog));
          catalog.items.splice(0, 0, item);
          catalog.items.forEach((c, i) => {
            c.position = i;
            c.changed = true;
          });
          pack = catalog;
        }
      }

      if (item.type === 'step') {
        const clonedItem = JSON.parse(JSON.stringify(item));
        let noChange = true;
        // iterando pelas questões
        item.items.length > 0 &&
          item.items.forEach((question, questionIndex) => {
            let hasChange = false;
            let hasFieldEmpty = false;
            // iterando pelas respostas
            question.items.length > 0 &&
              question.items.forEach((option, optionIndex) => {
                if (
                  option.changed ||
                  option.delete ||
                  option.optionTextChanged
                ) {
                  clonedItem.items[questionIndex].items[
                    optionIndex
                  ].changed = true;
                  hasChange = true;

                  if (option.name === '' && option.new) hasFieldEmpty = true;
                }
              });

            if (!hasFieldEmpty && (question.changed || hasChange)) {
              clonedItem.items[questionIndex].changed = true;
              noChange = false;
            }
          });

        if (!noChange) clonedItem.changed = true;

        pack = clonedItem;
      }

      pack = pack || item;
      const sourceCatalog = backupCatalog
        ? Builder.mountSchema(JSON.parse(JSON.stringify(backupCatalog)))
        : this.catalog;
      return CatalogAPI.saveCatalog(pack, sourceCatalog, true).then(
        response => {
          const errors = response.getErrors([]);
          if (errors.length > 0) {
            alert(StringLanguage.saveError);
          } else if (!this.configurations.catalogChanged) {
            StoreAPI.storeConfiguration({ catalogChanged: true }).then(
              response => {
                console.log(response);
                this.$store.dispatch('store/getConfigurations');
                this.getCatalog();
                store.commit('catalog/setReorderedSteps', false);
              }
            );
          } else {
            this.getCatalog();
            store.commit('catalog/setReorderedSteps', false);
          }
        }
      );
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.sortMode) {
      confirm(
        'Você não salvou sua nova ordenação, tem certeza que deseja sair?',
        res => {
          if (res) {
            next();
          } else {
            next(false);
          }
        }
      );
      return;
    }
    next();
  },
  computed: {
    ...mapState({
      isMobile: state => state.store.isMobile,
      configurations: state => state.store.configurations,
    }),
  },
};
</script>
<style scoped>
.box-category {
  margin-top: 40px;
}
.category-title {
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 5px;
  background-color: #212224;
  color: #cccccc;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.category-title i {
  font-size: 15px;
  margin-left: 15px;
}
.category-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.category-actions i {
  cursor: pointer;
  transition: color linear 0.15s;
}
.category-actions i:hover {
  color: #ff3382;
}
.box-product-container {
  display: flex;
  flex-wrap: wrap;
}
.box-product {
  flex: 0.5;
  max-width: 50%;
  min-width: calc(50% - 20px);
  min-height: 165px;
  background-color: var(--box);
  margin-bottom: 20px;
  margin-left: 10px;
  margin-right: 10px;
  padding: 20px;
  border-radius: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: var(--label-primary);
  cursor: pointer;
  box-sizing: border-box;
}
.box-product:nth-child(2n + 1) {
  margin-left: 0;
}
.box-product:nth-child(2n) {
  margin-right: 0;
}
.box-product--mobile {
  min-width: 100%;
  max-width: 100%;
  margin-left: 0;
  margin-right: 0;
}
.product-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.product-name {
  max-width: 100%;
  font-size: 14px;
  line-height: 20px;
  font-weight: bold;
}
.product-description {
  color: var(--label-primary);
  line-height: 18px;
  margin-top: 20px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.product-price {
  margin-top: auto;
  white-space: nowrap;
  color: var(--label-primary);
  font-weight: bold;
  margin-top: 20px;
}
.product-image {
  width: 125px;
  min-width: 125px;
  height: 125px;
  min-height: 125px;
  margin-left: 20px;
}
.product-image--none {
  background: var(--box-up);
  border-radius: 5px;
  border: 1px solid #656565c7;
  display: flex;
  justify-content: center;
  align-items: center;
}
.product-image--none i {
  font-size: 30px;
  color: #656565c7;
}
.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
}
.new-product {
  flex: 1;
  max-width: calc(50% - 10px);
  min-width: calc(50% - 20px);
  height: 165px;
  background: linear-gradient(45deg, #292a2d, #292a2d);
  margin-left: 10px;
  margin-right: 10px;
  font-weight: bold;
  border: 2px dashed #656565c7;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  font-size: 1.4em;
  color: #aaaaab;
  cursor: pointer;
  transition: filter 0.2s ease-in-out;
}
.new-product:nth-child(2n + 1) {
  margin-left: 0;
}
.new-product:nth-child(2n) {
  margin-right: 0;
}
.new-product:hover {
  filter: brightness(1.1);
}
.new-product i {
  font-size: 24px;
  margin-bottom: 15px;
}
.new-product--mobile {
  min-width: 100%;
  max-width: 100%;
  margin-left: 0;
  margin-right: 0;
}
.sorting {
  opacity: 0;
}
.icon {
  font-size: 1.2em;
}
.product-hidden {
  text-transform: uppercase;
  color: var(--default-hover);
  font-size: 1em;
}
.highlight {
  color: var(--default-hover);
  margin-right: 15px;
  font-size: 1em;
}
.search-box {
  display: flex;
  padding: 7px 20px 2px 20px !important;
}
.save-sort {
  background: var(--background-up);
  position: fixed;
  bottom: 58px;
  left: 0;
  width: 100%;
  padding: 10px 15px;
}

@media screen and (max-width: 991px) {
  .category-title {
    font-size: 1.4em;
  }
  .product-image {
    width: 80px;
    min-width: 80px;
    height: 80px;
    min-height: 80px;
  }
}
</style>
